import React from 'react';
import { renderRoutes } from 'react-router-config';
import { useLocation } from 'react-router-dom';
import routes, { matchPathToRoute } from 'router/routes';
import NotFound from 'pages/not-found';
function Navigator({ extraProps }) {
    const location = useLocation();
    const route = matchPathToRoute(location.pathname);
    return route ? renderRoutes(routes, extraProps) : <NotFound />;
}
export default Navigator;
